export const desktopSearchForm = () => {
  const root = document.querySelector('[data-search-desktop]');
  if (!root) return;

  const form = root.querySelector('[data-search-desktop-form]');
  const toggleBtn = root.querySelector('[data-search-desktop-toggle]');
  const panel = root.querySelector('[data-search-desktop-panel]');
  const input = root.querySelector('[data-search-desktop-input]');
  const submitBtn = root.querySelector('.search-form-desktop__submit');

  if (!form || !toggleBtn || !panel || !input || !submitBtn) return;

  const setState = () => {
    const hasValue = input.value.trim().length > 0;
    root.classList.toggle('search-form-desktop--filled', hasValue);
    root.classList.toggle('search-form-desktop--inactive', !hasValue && panel.hidden);
    root.classList.toggle('search-form-desktop--active', !panel.hidden);
    submitBtn.disabled = !hasValue;
  };

const open = () => {
  // aria
  toggleBtn.setAttribute('aria-expanded', 'true');

  // pokazujemy panel
  panel.hidden = false;

  // klasy stanu
  root.classList.remove('search-form-desktop--inactive');
  root.classList.add('search-form-desktop--active');

  // focus w input
  if (input) {
    requestAnimationFrame(() => {
      input.focus();
    });
  }
};

const close = () => {
  // aria
  toggleBtn.setAttribute('aria-expanded', 'false');

  // chowamy panel
  panel.hidden = true;

  // klasy stanu
  root.classList.remove('search-form-desktop--active');
  root.classList.add('search-form-desktop--inactive');
};
  const toggle = () => {
    const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
    isOpen ? close() : open();
  };

  // init
  // jeśli input ma wartość z URL (search page) -> filled
  setState();
  // jeśli nie jest active, panel ma być zamknięty
  if (!root.classList.contains('search-form-desktop--active')) {
    panel.hidden = true;
    toggleBtn.setAttribute('aria-expanded', 'false');
  }

  toggleBtn.addEventListener('click', (e) => {
    e.preventDefault();
    toggle();
  });

  input.addEventListener('input', () => {
    setState();
  });

  form.addEventListener('submit', (e) => {
    if (input.value.trim().length > 0) return;

    e.preventDefault();
    input.focus();
  });

  // klik poza -> zamknij
  document.addEventListener('click', (e) => {
    const clickedInside = e.target.closest('[data-search-desktop]');
    if (!clickedInside) close();
  });

  // ESC -> zamknij
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}; 